import React from 'react';
import { InputField, SelectField, SuiteField } from 'view/pages/Profile/Profile.styles';

interface IProps {
    onChange: (name: string, value: string) => void;
    suite: {
        type: string;
        number: string;
    }
}

const SuiteInput: React.FunctionComponent<IProps> = ({ onChange, suite: { type, number } }) => 
{
    return (
        <SuiteField>
            <SelectField onChange={(e) => onChange('type', e.target.value)}>
                <option value="" selected={type === ''}>Choose type</option>
                <option value="Ste" selected={type === 'Ste'}>Suite</option>
                <option value="Apt" selected={type === 'Apt'}>Apartment</option>
                <option value="Unit" selected={type === 'Unit'}>Unit</option>
            </SelectField>
            <InputField placeholder={
                type === 'Ste'
                    ? 'Suite No.'
                    : type === 'Apt'
                        ? 'Apartment No.'
                        : type === 'Unit'
                            ? 'Unit'
                            : 'Select suite type'
            } disabled={type === ''} onChange={(e) => onChange('number', e.target.value)} value={number} />
        </SuiteField>
    );
};

export default SuiteInput;